var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.componentName)?_c(_vm.componentName,_vm._b({tag:"component"},'component',_vm.componentParams,false)):_c('div',{directives:[{name:"output",rawName:"v-output",value:(_vm.text),expression:"text"}]})
}
var staticRenderFns = []

export { render, staticRenderFns }